export default __webpack_public_path__ + "static/media/logo.b4964dc9.svg";